let config = {
  token: null,
  reconfiguring: true,
};

window.config = config;

export default config;